import { api } from 'api';
import { checkMaintenance } from 'helpers/maintenance';
import { dispatchStore } from 'store';
import { SET_EVENTS, SET_EVENTS_ON_SIDEBAR } from 'store/action';
import { arrayUtils } from 'utils';

export const handleGetEventsAvailable = async (token) => {
  let { data } = await api.getEventsAvailable(token);
  if (data && !arrayUtils.isArrayEmpty(data)) {
    dispatchStore({ type: SET_EVENTS, payload: data });
  } else {
    dispatchStore({ type: SET_EVENTS, payload: null });
  }
};

export const handleGetAllEvents = async (token, cb = null) => {
  const { data } = await api.getAllEvents(token);

  if (data && !arrayUtils.isArrayEmpty(data)) {
    cb && cb(data);
  }
};

export const handleGetAllEventsPublic = async (cb = null) => {
  try {
    const { data } = await api.getEventsAvailablePublic();

    if (data && !arrayUtils.isArrayEmpty(data)) {
      dispatchStore({ type: SET_EVENTS, payload: data });
      cb && cb(data);
    } else {
      dispatchStore({ type: SET_EVENTS, payload: null });
      cb && cb(null);
    }
  } catch (error) {
    checkMaintenance(error);
    console.error(error?.message);
  }
};

export const handleGetEventsOnSidebar = async (token) => {
  const { data } = await api.getEventsOnSidebar(token);
  if (data && !arrayUtils.isArrayEmpty(data)) {
    dispatchStore({ type: SET_EVENTS_ON_SIDEBAR, payload: data });
  } else {
    dispatchStore({ type: SET_EVENTS_ON_SIDEBAR, payload: null });
  }
};
